import GitHubCalendar from "react-github-calendar";
import style from "./Calendar.module.css";
import React from "react";

const GitHubStats = () => {
  return (
    <div
      style={{
        padding: "20px",
        margin: "30px 0 0 0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
      className={style.gitCalender}
    >
      <p
        style={{
          margin: "30px 0 50px 0",
        }}
      >
        <h1 className="heading">
          My <span className="heading-highlight">Github</span> Stats
        </h1>
      </p>
      <div className={style.calender}>
        <GitHubCalendar color="red" username="gaurav78528" />
      </div>
      <div className={style.stats}>
        <a href="https://github.com/gaurav78528" data-aos="zoom-in-up">
          <img
            align="center"
            src="https://github-readme-streak-stats.herokuapp.com?user=gaurav78528&theme=dark"
            width="100%"
            alt="stats"
          />
        </a>

        <a href="https://github.com/gaurav78528" data-aos="zoom-in-up">
          <img
            align="center"
            src="https://github-readme-stats.vercel.app/api?username=gaurav78528&theme=dark&count_private=true&show_icons=true"
            alt="stats"
            width="100%"
          />
        </a>
      </div>
    </div>
  );
};
export default GitHubStats;
